import {createBrowserHistory} from 'history';

const history = createBrowserHistory();

history.listen(() => {
  window.scrollTo(0, 0);
});

export default history;
// import {createMemoryHistory} from 'history';

// const history =
//     process.env.NODE_ENV === 'test' ? createMemoryHistory() : createBrowserHistory();
//
// export default history
